import { statusClass } from '@/filters'

const VARIANT = ['positive', 'negative', 'warning', 'info', 'neutral', 'brand']

function replaceNameColor (color) {
  return color.replace('_color_', '')
}

export function statusTag (status) {
  if (!status) throw new Error('Missing status properties')
  const selfStatus = statusClass(status)
  const mappedEntries = Object.entries(selfStatus).map(([key, value]) => [
    replaceNameColor(key),
    value
  ])
  return mappedEntries.find(
    ([key, value]) => value && VARIANT.includes(key)
  )?.[0]
}
